import { render, staticRenderFns } from "./NumberedSteps.vue?vue&type=template&id=2c343490&"
import script from "./NumberedSteps.vue?vue&type=script&lang=js&"
export * from "./NumberedSteps.vue?vue&type=script&lang=js&"
import style0 from "./NumberedSteps.vue?vue&type=style&index=0&id=2c343490&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports